export function keikkaString_html(
  keikka,
  formatString = null,
  formatStringNumber = 0,
  isDarkMode = true,
  formatStringAdditions = ""
) {
  if (!keikka) return "";
  if (keikka.isKeikka || keikka.keikkaId > 0) {
    if (formatString === null) {
      if (formatStringNumber === 0)
        formatString =
          '<div class="keikkaString_html"><div>{osoite}</div><div>{asiakas}</div><div><b>{betoniMäärä}m3</b></div><div>{betoniLaatu}</div><div>#{keikkaId}</div><div>{foreignKey}</div>' +
          formatStringAdditions +
          "</div>";
      else if (formatStringNumber === 1)
        formatString =
          "<b>{tehdas}</b> {osoite} {asiakas} <b>{betoniMäärä}m3</b> {betoniLaatu} <b>{puomi}</b>" +
          formatStringAdditions;
    }
    var result = formatString;
    // tehdas
    result = result.replace("{tehdas}", keikka.betoniSijaintiLyh || "");
    {
      // puomi
      let puomi_pre = "B";
      if (keikka.vehicleTypeId === 3) puomi_pre = "P";
      else if (keikka.vehicleTypeId === 4) puomi_pre = "M";
      const formattedPumppuPuomi = keikka.pumppuPuomi?.toString().padStart(2, "0");
      result = result.replace("{puomi}", puomi_pre + formattedPumppuPuomi);
    }
    // osoite
    result = result.replace("{osoite}", keikka.tyomaaOsoite);
    // betoniMäärä
    result = result.replace(
      "{betoniMäärä}",
      String(keikka.m3).replace(".", ",").replace("null", "?")
    );
    // asiakas
    result = result.replace("{asiakas}", keikka.asiakasNimi);
    // betoniLaatu
    result = result.replace("{betoniLaatu}", keikka.laatuLyhenne + "{betoniLaatu} ");
    result = result.replace("{betoniLaatu}", keikka.raeKokoSelite + "{betoniLaatu} ");
    result = result.replace("{betoniLaatu}", keikka.lujuusSelite + "{betoniLaatu} ");
    result = result.replace("{betoniLaatu}", keikka.rasitusluokat + "{betoniLaatu} ");
    result = result.replace("{betoniLaatu}", keikka.kayttoIkaSelite);
    // keikkaId
    result = result.replace("{keikkaId}", keikka.keikkaId);
    // foreignKey
    result = result.replace("{foreignKey}", keikka.foreignKey);

    // Cleanup
    result = result.replaceAll("Ei tietoa", "").replaceAll("null", "");

    // remove double spaces and trim
    result = result.replace(/\s+/g, " ").trim();
    return result;
  } else if (keikka.isPalkki || keikka.palkkiId > 0) {
    let result = keikka.keikkaComment;
    if (!result) return "";
    if (result.indexOf("*bold") > -1) result = "<b>" + result.replace("*bold", "") + "</b>";

    if (result.indexOf("*blue") > -1)
      result =
        "<span style='color:" +
        (isDarkMode ? "blue" : "blue") +
        "'>" +
        result.replace("*blue", "") +
        "</span>";
    if (result.indexOf("*red") > -1)
      result = "<span style='color:red'>" + result.replace("*red", "") + "</span>";
    if (result.indexOf("*green") > -1)
      result = "<span style='color:green'>" + result.replace("*green", "") + "</span>";
    return result;
  }
}

export function getXPerc(_aika, gridSettings) {
  const aika = new Date();
  aika.setHours(23);
  aika.setMinutes(59);
  const maxX = getX(aika, gridSettings);
  const curX = getX(_aika, gridSettings);
  const xPerc = curX / maxX;
  return xPerc;
}

function getX(_aika, gridSettings) {
  const aikaH = new Date(_aika).getHours();
  const aikaM = new Date(_aika).getMinutes() / 60;
  const aikaDec = aikaH + aikaM;
  var x = 0;
  // if aikaH is before gridSettings.hideBeforeHour (h=4), return 0
  if (aikaDec <= gridSettings.hideBeforeHour) return x;

  // if aikaH is before gridSettings.shrinkBeforeHour (h=7)
  if (aikaDec <= gridSettings.shrinkBeforeHour) {
    // aikaH is before gridSettings.shrinkBeforeHour (h=7)
    const _hDiff = aikaDec - gridSettings.hideBeforeHour;
    x = (gridSettings.xMult * _hDiff) / gridSettings.shrinkFactor;
    return x;
  } else {
    // aikaH is after gridSettings.shrinkBeforeHour (h=7)
    const _hDiff = gridSettings.shrinkBeforeHour - gridSettings.hideBeforeHour;
    x = (gridSettings.xMult * _hDiff) / gridSettings.shrinkFactor;
  }

  // if aikaH is before gridSettings.shrinkAfterHour, return xMult * (gridSettings.shrinkAfterHour - gridSettings.shrinkBeforeHour)
  if (aikaDec <= gridSettings.shrinkAfterHour) {
    // aikaH is before gridSettings.shrinkAfterHour (h=16)
    const _hDiff = aikaDec - gridSettings.shrinkBeforeHour;
    x = x + gridSettings.xMult * _hDiff;
    return x;
  } else {
    // aikaH is after gridSettings.shrinkAfterHour (h=16)
    const _hDiff = gridSettings.shrinkAfterHour - gridSettings.shrinkBeforeHour;
    x = x + gridSettings.xMult * _hDiff;
  }

  if (aikaDec <= gridSettings.hideAfterHour) {
    x =
      x +
      (gridSettings.xMult * (aikaDec - gridSettings.shrinkAfterHour)) / gridSettings.shrinkFactor;
  } else {
    const hDiff = gridSettings.hideAfterHour - gridSettings.shrinkAfterHour + 1;
    x = x + (gridSettings.xMult * hDiff) / gridSettings.shrinkFactor;
  }
  return x;
}
